(function() {
  'use strict';
  
  angular
    .module('app.debounce', []);
  
})();